import type { OpportunityLimits, OpportunityCycle, TimeframeKey, Plan } from '../types'

export function getDefaultLimits(): OpportunityLimits {
  return { active_cycle: 'month', mode: 'unlimited' }
}

export function getLimitsFromPlan(plan?: Plan | null): OpportunityLimits {
  try {
    const raw = (plan?.meta as any)?.opportunity_limits
    if (!raw || typeof raw !== 'object') return getDefaultLimits()
    const cycle = (raw.active_cycle as OpportunityCycle) || 'month'
    const mode = (raw.mode as 'unlimited'|'fixed') || 'unlimited'
    const total = typeof raw.total === 'number' ? Math.max(0, Math.floor(raw.total)) : undefined
    const allocations = sanitizeAllocations(raw.allocations || {})
    return { active_cycle: cycle, mode, total, allocations }
  } catch {
    return getDefaultLimits()
  }
}

export function sanitizeAllocations(a: Record<string, any> | undefined): Partial<Record<TimeframeKey, number>> | undefined {
  if (!a || typeof a !== 'object') return undefined
  const out: Partial<Record<TimeframeKey, number>> = {}
  // Somente TFs mandantes (alvo): 60, 240, 720, D, W, M
  const keys: TimeframeKey[] = ['60','240','720','D','W','M']
  for (const k of keys) {
    const v = Number((a as any)[k])
    if (Number.isFinite(v) && v > 0) out[k] = Math.floor(v)
  }
  return Object.keys(out).length ? out : undefined
}

export function sumAllocations(alloc?: Partial<Record<TimeframeKey, number>>): number {
  if (!alloc) return 0
  return (Object.values(alloc) as number[]).reduce((acc, n) => acc + (Number.isFinite(n) ? n : 0), 0)
}

export function validateAllocations(total: number, alloc?: Partial<Record<TimeframeKey, number>>): { ok: boolean; delta: number } {
  const s = sumAllocations(alloc)
  const t = Math.max(0, Math.floor(Number(total) || 0))
  return { ok: s === t, delta: t - s }
}
